import axios from "axios";

export const getPeopleCategories = async () => {
  const url =
    process.env.REACT_APP_BASE_LINK + "/api/categories-of-people?populate=*";

  return await axios
    .get(url)
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getPeople = async (peopleId) => {
  const url =
    process.env.REACT_APP_BASE_LINK + `/api/people/${peopleId}?populate=*`;

  return await axios
    .get(url)
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => {
      console.log(error);
    });
};
